<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Type_spots"
    :submit="submit" :status="status" :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/type_spots'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="name" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Nombre</div>
                <v-text-field :error-messages="errors" v-model="data.name" label="Nombre" solo hide-details="auto"
                  class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <div class="label-base pb-1">Descripción</div>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.description" solo placeholder="Descripción"
                  hide-details="auto" class="text-tarea-base" rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="profile_picture" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Imagen</div>
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                  prepend-icon="fas fa-camera" placeholder="Imagen" label="" :multiple="false"
                  :onSelectedPicture="onSelectedPicture"></Upload>
                <v-img :src="picture" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="type" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Tipo</div>
                <v-select :error-messages="errors" v-model="data.type" label="Tipo" :items="types" solo
                  hide-details="auto" class="input-base" append-icon="$caretDownFormIcon">
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="hide" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Ocultar Tipo de Spot</div>
                <v-switch
                    v-model="data.hide"
                    :error-messages="errors"
                    label="¿Ocultar este tipo de spot?"
                    hide-details="auto"
                    class="input-base"
                ></v-switch>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="type" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Comodidades</div>
                <v-select :error-messages="errors" v-model="data.amenities" label="Comodidades" :items="amenities"
                  item-text="name" item-value="id" multiple solo hide-details="auto" class="input-base"
                  append-icon="$caretDownFormIcon">
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import Upload from "@/components/Upload";
export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm, Upload },
  computed: {
    ...mapState({
      status: state => state.Type_spots.status,
      amenities: state => state.Amenities.list
    })
  },
  data() {
    return {
      picture: "",
      filteredAttributes: ["picture"],
      storeName: "Type_spots",
      title: "Tipo de Spot",
      types: ["garaje", "drive_away", "on_street", "parking", "multispot", "space_report", "merchant"],
      data: {
        name: "",
        description: "",
        type: "",
        picture: null,
        amenities: [],
        type_spot_amenities: [],
        hide: false
      }
    };
  },
  watch: {
    "data.type_spot_amenities": {
      handler(val) {
        if (val && val.length) {
          this.data.amenities = val.map(item => item.amenity_id);
        }
      },
      immediate: true
    }
  },
  methods: {
    onSelectedPicture(file) {
      const self = this;
      this.data.picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.picture = fr.result;
      };
      fr.onerror = function () {
        self.picture = "";
      };
      fr.readAsDataURL(this.data.picture);
    }
  },
  created() {
    this.$store.dispatch("Amenities/getListAll", { show_all: "enable" });
  }
};
</script>
